<template>
  <v-app>
    <v-container fill-height>
      <v-row align="center" justify="center">
        <v-col cols="12" class="d-flex justify-center">
          <v-card class="sigfloCard" width="450">
            <v-card-text class="pt-4 textEmphasis sigfloBodyLarge text-center" v-show="!success">
              <div class="mb-2">Reset Password</div>
              <v-form ref="changePasswordForm" submit-prevent>
                <v-text-field
                  label="New Password"
                  outlined
                  filled
                  required
                  v-model="password"
                  :rules="passwordRule"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showPassword ? 'text' : 'password'"
                  @click:append="showPassword = !showPassword"
                ></v-text-field>
                <v-text-field
                  label="Confirm New Password"
                  outlined
                  filled
                  required
                  :rules="[passwordMatchRule]"
                  v-model="password2"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showPassword ? 'text' : 'password'"
                  @click:append="showPassword = !showPassword"
                ></v-text-field>
                <v-btn rounded class="sigfloButton400 text-capitalize" color="primary" @click="resetPassword"
                  >change password</v-btn
                >
                <div class="mt-2 sigfloBodyMedium red--text">{{ error }}</div>
              </v-form>
            </v-card-text>
            <v-card-text v-show="success" class="text-center">
              <div class="sigfloBodyLarge mb-4">Password reset successfully!</div>
              <v-btn rounded class="sigfloButton400 text-capitalize" color="primary" @click="showLoginDialog"
                >Log In</v-btn
              >
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
  export default {
    data() {
      return {
        token: null,
        email: null,
        password: null,
        password2: null,
        showPassword: false,
        success: false,
        error: ''
      };
    },
    mounted() {
      this.token = this.$route.query.token;
      this.email = this.$route.query.email;
    },
    methods: {
      resetPassword() {
        if (this.$refs.changePasswordForm.validate()) {
          const payload = {
            email: this.email,
            password: this.password,
            token: this.token
          };
          this.$store.dispatch('app/resetPassword', payload).then((response) => {
            if (response.status === 200) {
              this.error = null;
              this.success = true;
              this.$store.dispatch('app/showSuccess', 'Password changed successfully');
            } else {
              if (response && response.message) {
                this.error = response.message;
              } else {
                this.error = 'An error occurred setting your password, please try again.';
              }
            }
          });
        }
      }
    }
  };
</script>

<style>
  .logoAvatar {
    position: absolute;
    top: -25px;
    left: 50%;
    transform: translateX(-50%);
  }
</style>
